import { baseApi, createEndpointBuilder } from '@/shared/api';
import { API_TAGS } from '@/shared/api/tags';
import type { Context, Badges, PasswordChange, UserContext, ProjectData } from '../model/types';

const layoutEndpoint = createEndpointBuilder('/api/v1/layout');

export const layoutApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getContext: builder.query<Context, void>({
      query: () => layoutEndpoint('/context'),
      providesTags: [API_TAGS.LAYOUT]
    }),

    getUserContext: builder.query<UserContext, void>({
      query: () => layoutEndpoint('/user-context'),
      providesTags: [API_TAGS.LAYOUT]
    }),

    getProjectData: builder.query<ProjectData, { siteId?: number; projectId?: number }>({
      query: ({ siteId, projectId }) => ({
        url: layoutEndpoint('/project-data'),
        params: { siteId, projectId }
      }),
      providesTags: (_result, _error, { siteId, projectId }) => [
        { type: API_TAGS.LAYOUT, id: `${projectId}-${siteId}` }
      ]
    }),

    getBadges: builder.query<Badges, void>({
      query: () => layoutEndpoint('/badges'),
      providesTags: [API_TAGS.LAYOUT]
    }),

    changePassword: builder.mutation<void, PasswordChange>({
      query: (passwordData) => ({
        url: layoutEndpoint('/user/password'),
        method: 'PUT',
        body: passwordData
      })
    }),

    switchProject: builder.mutation<Context, number>({
      query: (projectId) => ({
        url: layoutEndpoint(`/context/project/${projectId}`),
        method: 'PUT'
      }),
      invalidatesTags: [API_TAGS.LAYOUT]
    }),

    switchSite: builder.mutation<Context, number>({
      query: (siteId) => ({
        url: layoutEndpoint(`/context/site/${siteId}`),
        method: 'PUT'
      }),
      invalidatesTags: [API_TAGS.LAYOUT]
    })
  })
});

export const {
  useGetContextQuery,
  useGetUserContextQuery,
  useGetProjectDataQuery,
  useGetBadgesQuery,
  useChangePasswordMutation,
  useSwitchProjectMutation,
  useSwitchSiteMutation,
  useLazyGetContextQuery,
  useLazyGetUserContextQuery,
  useLazyGetProjectDataQuery,
  useLazyGetBadgesQuery
} = layoutApi;
